import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocClickService {
  documentClickedTarget: Subject<HTMLElement> = new Subject<HTMLElement>()
  constructor() { }
}
